import React from 'react';
import {
  Label,
  TextField,
  Text,
  Stack,
  Icon,
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  ChoiceGroup
} from '@fluentui/react';
import ComboBoxInput from '../../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import ToggleInput from '../../../lib/FormValidator/Form/ToggleInput';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import useForceUpdate from '../../../common/custom-hooks/useForceUpdate';
import { AppContext } from '../../../AppInRouterContext';
import RegistroEntrenadorCursoForm from '../../RegistroEntrenadorCurso/RegistroEntrenadorCursoForm';

interface ICursos {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
  appContext: AppContext;
  onNextEnable: (valid: boolean) => void;
}

export const Cursos = ({ form, onBlurCustomInput, system, courier, appContext, onNextEnable}: ICursos) => {

  const [showAddAnother, setShowAddAnother] = React.useState(false);

  const [cursoForm, setCursoForm] = React.useState<RegistroEntrenadorCursoForm>(
    RegistroEntrenadorCursoForm.initialize()
  );

  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);

  const cursosList = useCustomInput(() => form.getCursoEntrenadorListInput(), [form]);

  React.useEffect(() => {
    if (cursosList.getValue().length > 0) {
      setShowAddAnother(true);
      onNextEnable(true);
    }
  }, []);

  const addCurso = () => {
    const cursos = [...cursosList.getValue()];
    cursos.push(cursoForm.toRegistroEntrenadorCurso());
    cursosList.setValue(cursos);
    setCursoForm(RegistroEntrenadorCursoForm.initialize());
    onBlurCustomInput(cursosList);
    setShowAddAnother(true);
    onNextEnable(true);
  };

  const onBlurTitulos = (customInput: CustomInputIfc) => {
    if (cursoForm) {
      const isValid = cursoForm.getIdInput().getValue()
        ? !cursoForm.hasErrors()
        : cursoForm?.isValid();
      setFormIsValid(isValid);
      forceUpdate();
      return isValid;
    }
    return false;
  };

  // React.useEffect(() => {
  //   console.log(cursosList.getValue());
  // }, [cursosList]);

  const onRenderIndexColumn = (item?: any, index?: number, column?: any) => {
    return <span>{index !== undefined ? index + 1 : ''}.</span>;
  };

  const columns = [
    {
      key: 'index',
      name: '',
      fieldName: 'index',
      minWidth: 3,
      maxWidth: 3,
      onRender: onRenderIndexColumn,
    },
    {
      key: 'descripcion',
      name: 'Descripcion',
      fieldName: 'descripcion',
      minWidth: 120,
      maxWidth: 120,
      isMultiline: true,
    },
    {
      key: 'tipo',
      name: 'Tipo',
      fieldName: 'tipo',
      minWidth: 35,
      maxWidth: 35,
      isMultiline: true,
    },
    {
      key: 'exterior',
      name: 'Región',
      fieldName: 'exterior',
      minWidth: 50,
      maxWidth: 60,
      isMultiline: true,
      onRender: (item: any) => {
        return <span>{item.exterior ? 'Exterior' : 'Argentina'}</span>;
      },
    },
    {
      key: 'delete',
      name: '',
      fieldName: 'delete',
      minWidth: 10,
      maxWidth: 10,
      onRender: (item: RegistroEntrenadorCursoForm) => (
        <Icon iconName="Trash" onClick={() => handleDelete(item)} styles={iconStyles} />
      ),
    },
  ];

  const handleDelete = (cursoDelete: RegistroEntrenadorCursoForm) => {
    cursosList.setValue(
      cursosList
        .getValue()
        .filter((curso: RegistroEntrenadorCursoForm) => curso !== cursoDelete)
    );
    onBlurCustomInput(cursosList);
  };

  const iconStyles = {
    root: {
      cursor: 'pointer',
      fontSize: '20px',
    },
  };

  const CursoTipoOptions = [
    { key: 'T', text: 'Tomado' },
    { key: 'D', text: 'Dictado' },
  ];

  const disableAdd = () => {
    return !cursoForm.getDescripcionInput().getValue() || !cursoForm.getTipoInput().getValue() || !cursoForm.getHorasInput().getValue() || (parseInt(cursoForm.getHorasInput().getValue()) < 15);
  }
  
  const disableCancel = () => {
    const tieneDatos = cursoForm.getDescripcionInput().getValue() || //falta preguntar por TIPO
    cursoForm.getHorasInput().getValue();

    if (tieneDatos) {
      onNextEnable(false);
      return false;
    } else {
       return true;
    }
  
  }

  const cancelAdd = () => {
    setCursoForm(RegistroEntrenadorCursoForm.initialize());
    onNextEnable(true);
  }

  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        <Text
          className="mb-1"
          variant="small"
          styles={{ root: { textAlign: 'center', color: '#666', display: 'block' } }}
        >
          No menores a 15 horas reloj de clase.
        </Text>

        {showAddAnother ? (
          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12 form-item">
              <DefaultButton
                onClick={() => setShowAddAnother(false)}
                text="Agregar otro"
                styles={{ root: { width: '100%' } }}
                primary
              />
            </div>
          </div>
        ) : (
          <>
            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item">
                <InputField
                  input={cursoForm.getHorasInput()}
                  label={'Cant. Horas'}
                  onBlur={onBlurCustomInput}
                  propsInput={{ type: 'number', inputMode: 'numeric' }}
                />
              </div>
              <div className="ms-Grid-col ms-sm6 form-item" style={{display: 'flex', justifyContent: 'center'}}>
                {/* <ComboBoxInput
                  input={cursoForm.getTipoInput()}
                  label={'Tipo'}
                  onBlur={onBlurCustomInput}
                  options={CursoTipoOptions}
                /> */}
                <ChoiceGroup
                  selectedKey={cursoForm.getTipoInput().getValue()}
                  options={CursoTipoOptions.map((option) => ({
                    key: option.key,
                    text: option.text,
                  }))}
                  onChange={(e: any, option: any) => {
                    cursoForm.getTipoInput().setValue(option?.key);
                    onBlurCustomInput(cursoForm.getTipoInput());
                  }}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <InputField
                  input={cursoForm.getDescripcionInput()}
                  label={'Datos del curso (Dependencia, Materia, Etc.)'}
                  onBlur={onBlurCustomInput}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm6 form-item" style={{ display: 'flex', flexDirection: 'row' }}>
                <Label className="mr-2" style={{ padding: 0 }}>
                  Región
                </Label>
                <ToggleInput
                  input={cursoForm.getExteriorInput()}
                  offText={'Argentina'}
                  onText={'Exterior'}
                  onBlur={onBlurCustomInput}
                />
              </div>
            </div>

            <div className="ms-Grid-row mt-2">
              <div className="ms-Grid-col ms-sm12 form-item">
                <DefaultButton
                  disabled={disableAdd()}
                  onClick={addCurso}
                  text="Agregar"
                  styles={{ root: { width: '100%' } }}
                  primary
                />
                 {<DefaultButton 
                  disabled={disableCancel()} 
                  onClick={cancelAdd} 
                  text="Cancelar"
                  styles={{ root: { width: '100%', marginTop: 8} }} />}
              </div>
            </div>
          </>
        )}

        {/* {cursosList.getValue().map((titulo: RegistroEntrenadorTitulo, index: number) => ( */}
        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <DetailsList
              items={cursosList.getValue()}
              columns={columns}
              layoutMode={DetailsListLayoutMode.fixedColumns}
              selectionMode={SelectionMode.none}
            />
          </div>
        </div>
        {/* ))} */}
      </div>
    </div>
  );
};
